import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-31389e4d"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "map_container"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "amap"
}, null, -1));
const _hoisted_3 = {
  class: "searchbox flex_column"
};
const _hoisted_4 = {
  key: 0,
  class: "marquee flex_FSBC mt10",
  style: {
    "width": "100%"
  }
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex_size_1 pl10"
}, "选择省市区后搜索会更精确哦~", -1));
const _hoisted_6 = {
  class: "flex_FCAC flex_size_1 mt20"
};
const _hoisted_7 = {
  key: 0,
  class: "search_list"
};
const _hoisted_8 = {
  class: "flex_size_1 pl10 pr10"
};
const _hoisted_9 = {
  class: "map_left flex"
};
const _hoisted_10 = {
  class: "ml10"
};
const _hoisted_11 = {
  key: 0,
  class: "marquee flex_FSBC"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex_size_1 pl5 pr5"
}, " 定位若有偏差,可通过搜索选择精确位置！ ", -1));
const _hoisted_13 = {
  key: 1,
  class: "user_loc flex_FSBC"
};
const _hoisted_14 = {
  class: "flex_size_1 pl10 pr10"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_cascader = _resolveComponent("el-cascader");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_tooltip = _resolveComponent("el-tooltip");
  const _component_el_input = _resolveComponent("el-input");
  const _component_Warning = _resolveComponent("Warning");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_row = _resolveComponent("el-row");
  const _component_Location = _resolveComponent("Location");
  const _component_el_text = _resolveComponent("el-text");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_divider = _resolveComponent("el-divider");
  const _component_el_empty = _resolveComponent("el-empty");
  const _component_CircleClose = _resolveComponent("CircleClose");
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_row, {
    style: {
      "padding": "0 1.0417vw"
    },
    gutter: 10
  }, {
    default: _withCtx(() => [_createVNode(_component_el_tooltip, {
      content: $setup.data.cascaderValue.join('>'),
      placement: "top"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(() => [_createVNode(_component_el_cascader, {
          modelValue: $setup.data.cascaderValue,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.data.cascaderValue = $event),
          options: $setup.data.city,
          props: $setup.data.cascaderProps,
          separator: ">",
          onChange: $setup.handleCity,
          placeholder: "请选择省市区"
        }, null, 8, ["modelValue", "options", "props", "onChange"])]),
        _: 1
      })]),
      _: 1
    }, 8, ["content"]), _createVNode(_component_el_col, {
      span: 16
    }, {
      default: _withCtx(() => [_createVNode(_component_el_tooltip, {
        content: "按Enter键搜索",
        placement: "top"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          clearable: "",
          modelValue: $setup.data.addressValue,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $setup.data.addressValue = $event),
          placeholder: "请输入地址",
          onKeydown: _withKeys($setup.searchAddress, ["enter"]),
          onClear: $setup.clearAddressValue
        }, null, 8, ["modelValue", "onKeydown", "onClear"])]),
        _: 1
      })]),
      _: 1
    }), !$setup.data.cascaderValue.length ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_el_icon, {
      size: ".8vw"
    }, {
      default: _withCtx(() => [_createVNode(_component_Warning)]),
      _: 1
    }), _hoisted_5])) : _createCommentVNode("", true)]),
    _: 1
  }), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [$setup.data.list.length ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.list, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      class: "search_list_item flex_FSBC",
      key: index
    }, [_createVNode(_component_el_icon, {
      size: "1vw"
    }, {
      default: _withCtx(() => [_createVNode(_component_Location)]),
      _: 1
    }), _createElementVNode("div", _hoisted_8, [_createElementVNode("p", null, _toDisplayString(item.name), 1), _createVNode(_component_el_text, {
      size: "small"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(item.pname + item.cityname + item.adname + item.address), 1)]),
      _: 2
    }, 1024)]), _createVNode(_component_el_tooltip, {
      effect: "dark",
      content: "选择地址",
      placement: "top"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_button, {
        type: "success",
        icon: "Check",
        circle: "",
        onClick: () => $setup.selectListAddress(index)
      }, null, 8, ["onClick"])]),
      _: 2
    }, 1024), _createVNode(_component_el_tooltip, {
      effect: "dark",
      content: "地图查看",
      placement: "top"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_button, {
        type: "primary",
        icon: "MapLocation",
        circle: "",
        onClick: () => $setup.toViewMapLocation(index)
      }, null, 8, ["onClick"])]),
      _: 2
    }, 1024)]);
  }), 128)), _createVNode(_component_el_divider, null, {
    default: _withCtx(() => [_createTextVNode("到底咯~")]),
    _: 1
  })])) : (_openBlock(), _createBlock(_component_el_empty, {
    key: 1,
    description: "暂无数据"
  }))])), [[_directive_loading, $setup.data.loading]])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [$setup.data.isShowTips ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(_component_el_icon, {
    size: ".8vw"
  }, {
    default: _withCtx(() => [_createVNode(_component_Warning)]),
    _: 1
  }), _hoisted_12, _createVNode(_component_el_icon, {
    class: "pointer",
    size: ".8vw",
    onClick: $setup.closeTips
  }, {
    default: _withCtx(() => [_createVNode(_component_CircleClose)]),
    _: 1
  }, 8, ["onClick"])])) : _createCommentVNode("", true), $setup.data.currentUserPosition?.address ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createVNode(_component_el_icon, {
    size: "1vw"
  }, {
    default: _withCtx(() => [_createVNode(_component_Location)]),
    _: 1
  }), _createElementVNode("div", _hoisted_14, [_createElementVNode("p", null, _toDisplayString($setup.data.currentUserPosition?.address), 1), $setup.data.currentUserPosition?.desc ? (_openBlock(), _createBlock(_component_el_text, {
    key: 0,
    size: "small"
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.data.currentUserPosition?.desc), 1)]),
    _: 1
  })) : _createCommentVNode("", true)]), _createVNode(_component_el_button, {
    type: "primary",
    onClick: $setup.sendCurrentAddress
  }, {
    default: _withCtx(() => [_createTextVNode("选择")]),
    _: 1
  }, 8, ["onClick"])])) : _createCommentVNode("", true)])])]);
}